<script>
export default {
  data() {
    return {
      logo: require("../../assets/logo_medviu.svg"),
      setting: {}
    };
  },
  metaInfo: {
    title: "Intranet Medviu"
  },
};
</script>

<template>
  <div class="public-view">
    <div class="public-view-wrapper">
      <div class="public-view-header">
        <div class="container-fluid">
          <div class="row">
            <div class="col-8">
              <div class="logo"></div>
            </div>
            <div class="col-4">
              <div class="languages">
                <b-link @click="changeLocale('de')">DE</b-link>
                <b-link @click="changeLocale('fr')"> FR </b-link>
                <b-link @click="changeLocale('it')"> IT</b-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="public-view-article-wrapper">
        <div class="contentsection">
          <slot></slot>
        </div>
      </div>
    </div>
    <div class="public-view-footer">
      <div class="infoline">
        <span class="about">{{ $t("about.sangit") }}</span
        ><span>, </span>
        <a href="tel: +41 71 330 03 75">{{ $t("about.phone") }}</a
        ><span>, </span>
        <a href="mailto:contact@medviu.ch">{{
          $t("about.contact_mail")
        }}</a
        ><span>, </span>
        <a href="http://www.medviu.ch" target="_blank">{{
          $t("about.web")
        }}</a>
      </div>
    </div>
  </div>
</template>
